import React, { useState } from "react";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";
import { ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";

export default function ModelExtraEscrow({ setExtraModal, extraData, proposalmilestones }) {
  const [amount, setAmount] = useState(extraData?.extra_amount || 0);
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung") || "en";

  const handleRedirect = () => {
    navigate(`/${laung}/account/paymentmethodpage`, {
      state: {
        orderdetails: {
          type: 17,
          proposal_id: proposalmilestones?.id,
          post_price: amount,
        },
      },
    });
    setExtraModal(false);
  };

  return (
    <>
      <div className="add-task m-0">
        <h6>Additional Funds Required</h6>
        <button
          onClick={() => setExtraModal(false)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <p>{extraData?.message || "Deposit exceeded. Please add additional funds to approve this log time"}</p>
        <div className="form-group mt-3">
          <label>Additional Amount ($)</label>
          <input
            type="number"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            min={extraData?.extra_amount || 0}
          />
        </div>
      </ModalBody>

      <div className="modal-footer flex-nowrap mt-3" style={{ columnGap: '32px' }}>
        <button
          onClick={() => setExtraModal(false)}
          className="btn"
          style={{ background: "#fff", color: "black", border: "2px solid" }}
        >
          Cancel
        </button>
        <button
          onClick={handleRedirect}
          className="btn"
        >
          Redirect to Payment
        </button>
      </div>
    </>
  );
}
